import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { ImageTypesEnum, S3BucketEnum } from '../../common/general-types/media-assets.dto';
import { S3uploaderService } from '../../services/s3uploader/s3uploader.service';

@Component({
  selector: 'atom-add-document',
  standalone: true,
  imports: [],
  templateUrl: './add-document.component.html',
  styleUrl: './add-document.component.css'
})
export class AddDocumentComponent implements OnInit {

  /** Matches file input accept list and CSV via MIME or `.csv` extension (drag-drop may omit MIME). */
  static isAllowedDocument(file: File): boolean {
    const type = file.type;
    const name = file.name.toLowerCase();
    const isCsv =
      type === 'text/csv' || type === 'application/csv' || name.endsWith('.csv');

    return (
      type.startsWith('application/pdf') ||
      type.startsWith('application/msword') ||
      type.startsWith('application/vnd.openxmlformats-officedocument.wordprocessingml.document') ||
      type.startsWith('text/txt') ||
      isCsv
    );
  }

  @Input() initialDocument: string | undefined = undefined;
  @Input() bucket: S3BucketEnum = S3BucketEnum.CREATORS_CSV;

  @Output() documentUploaded = new EventEmitter<{ file: string, fileKey: string, fullUrl: string }>();

  /** Selected Product Photos */
  selectedFiles: any[] = [];
  completeDocument = signal<any>('');
  completeDocumentType = signal<any>('');
  documentLoading: boolean = false;
  isDragging = signal<boolean>(false);

  private uploadService = inject(S3uploaderService);
  
  ngOnInit(): void {
    if (this.initialDocument) {
      this.completeDocument.set(this.initialDocument);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging.set(true);
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging.set(false);
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging.set(false);

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      // Allowed document types (PDF, Word, TXT, CSV)
      const documentFiles: File[] = [];
      for (let i = 0; i < files.length; i++) {
        const file = files.item(i);
        if (file && AddDocumentComponent.isAllowedDocument(file)) {
          documentFiles.push(file);
        }
      }

      if (documentFiles.length > 0) {
        // Create a FileList-like object that works with the upload service
        const fileListLike = {
          length: documentFiles.length,
          item: (index: number) => documentFiles[index] || null,
          [Symbol.iterator]: function* () {
            for (let i = 0; i < documentFiles.length; i++) {
              yield documentFiles[i];
            }
          }
        } as FileList;

        // Create a mock event object with files property to reuse selectFile logic
        const mockEvent = {
          target: {
            files: fileListLike
          }
        };
        this.selectFile(mockEvent);
      }
    }
  }

  selectFile(event: any): void {
    console.log('selectFile() -> ', event);
    this.selectedFiles = event.target.files;
    this.upload(this.selectedFiles);
  }

  async upload(selectedFiles: any) {
    const uploadedFile = await this.uploadService.uploadDocument(selectedFiles, this.bucket);
    console.log('uploadedFile: ', uploadedFile);
    if (uploadedFile) {
      this.completeDocument.set(uploadedFile.fileKey);
      this.completeDocumentType.set(uploadedFile.fileType);
      this.documentLoading = false;
      this.documentUploaded.emit({ file: uploadedFile.file, fileKey: uploadedFile.fileKey, fullUrl: uploadedFile.fullUrl });
    } else {
      console.warn('Upload failed or canceled.');
      this.documentLoading = false;
    }
  }
}
